export default "__VITE_ASSET__CVoY90yK__"